<template lang="pug">
    div.paymentInformation
        div
            // Title
            title-component(type="h4" :title="$t('payments.payment.title')")

        v-layout.align-center.c-form(raw wrap v-if="subscriptionStatus !== 'canceled'")
            v-flex(xs12)

                // Package type selection
                div
                    v-select(
                        name="packageType"
                        append-icon="expand_more"
                        outline
                        v-model="packageType"
                        :items="['plan_20_monthly', 'plan_130_annual'].includes(packageType) ? $t('selection.packagesProfile') : $t('selection.packagesProfileNoTrial')"
                        :label="$t('fields.packageType')"
                    )

            v-flex(xs12 sm7)

                // Card number
                v-text-field(
                    :label="$t('fields.cardNumber')"
                    append-icon="credit_card"
                    hide-details
                    disabled
                    readonly
                    name="cardNumber"
                    :value="lastDigits"
                    outline
                )

            v-flex(xs12 sm5)

                // Update card button
                button-component.ma-0.update.updateButton(
                    block
                    large
                    :action="updateCard"
                    color="primary"
                ) {{ $t('defaultButtons.changePayment') }}

        v-layout.align-center.c-form(raw wrap)
            v-flex.mt-1(xs12)
                div {{ user.subscriptionStatus !== 'canceled' ? `Next Payment Date: ` : `Subscription Valid Until: ` }}
                    b {{ nextPaymentDate | FormatedDateLong }}
</template>

<script>
    import Button from '~components/Button';
    import Title from '~components/Title';
    import { mapFields } from 'vuex-map-fields';
    import { mapActions, mapGetters } from 'vuex';
    import FormatedDateLong from '~filters/FormatedDateLong';

    export default {
        components: {
            TitleComponent: Title,
            ButtonComponent: Button
        },
        filters: {
            FormatedDateLong
        },
        computed: {
            ...mapFields('payments', ['packageType']),
            ...mapGetters('payments', ['lastDigits']),
            ...mapGetters('auth', [
                'user',
                'subscriptionStatus',
                'isStripeSubscription'
            ]),

            nextPaymentDate() {
                return this.user && this.user.subscription
                    ? this.user.subscription.currentPeriodEndedAt
                    : '';
            }
        },
        watch: {
            packageType(val, oldVal) {
                if (!oldVal) return;
                if (val !== oldVal) {
                    if (val === 'canceled') return this.deleteSubscription();

                    if (oldVal === 'canceled' && val !== 'canceled') {
                        this.createSubscription();
                    }

                    return this.updateSubscription();
                }
            }
        },
        created() {
            if (this.isStripeSubscription) {
                this.getCards();
            }
            this.setPackageType();
        },
        methods: {
            ...mapActions('payments', [
                'updateSubscription',
                'createSubscription',
                'deleteSubscription',
                'setPackageType',
                'getCards'
            ]),
            updateCard() {
                this.$router.push({ name: 'dashboard.updateCard' });
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../../assets/style/_variables.styl"

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .updateButton
            margin: 16px 0 !important
</style>
